import { HeadSyncOutlineIcon } from './HeadSyncOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8EC8806B-0E06-4EA4-915E-C061D4930ECC
 * name head-sync-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-sync-outline.svg
 * tags
 */
export const HeadRefreshOutlineIcon = HeadSyncOutlineIcon;
export default HeadRefreshOutlineIcon